module.exports = __webpack_public_path__ + "img/logo-dne-merchant.438c83e5.svg";